"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadPreferenceHistoryGetDTO = exports.LeadPreferenceHistoryFilter = exports.LeadPreferenceHistoryCreateDTO = exports.LeadPreferenceHistoryDTO = exports.FuelType = exports.TransmissionType = exports.CarCondition = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const global_1 = require("../../../../global");
const lead_dto_1 = require("./lead_dto");
const core_1 = require("../../../../core");
var CarCondition;
(function (CarCondition) {
    CarCondition["NEW"] = "NEW";
    CarCondition["USED"] = "USED";
    CarCondition["BOTH"] = "BOTH";
})(CarCondition = exports.CarCondition || (exports.CarCondition = {}));
var TransmissionType;
(function (TransmissionType) {
    TransmissionType["AUTOMATIC"] = "AUTOMATIC";
    TransmissionType["MANUAL"] = "MANUAL";
    TransmissionType["BOTH"] = "BOTH";
})(TransmissionType = exports.TransmissionType || (exports.TransmissionType = {}));
var FuelType;
(function (FuelType) {
    FuelType["PETROL"] = "PETROL";
    FuelType["DIESEL"] = "DIESEL";
    FuelType["ELECTRIC"] = "ELECTRIC";
    FuelType["HYBRID"] = "HYBRID";
    FuelType["ANY"] = "ANY";
})(FuelType = exports.FuelType || (exports.FuelType = {}));
class LeadPreferenceHistoryDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(LeadPreferenceHistoryDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => lead_dto_1.LeadDTO),
    __metadata("design:type", lead_dto_1.LeadDTO)
], LeadPreferenceHistoryDTO.prototype, "lead", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], LeadPreferenceHistoryDTO.prototype, "budgetMin", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], LeadPreferenceHistoryDTO.prototype, "budgetMax", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryDTO.prototype, "preferredMake", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryDTO.prototype, "preferredModel", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], LeadPreferenceHistoryDTO.prototype, "preferredYearMin", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], LeadPreferenceHistoryDTO.prototype, "preferredYearMax", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], LeadPreferenceHistoryDTO.prototype, "preferredColors", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], LeadPreferenceHistoryDTO.prototype, "preferredFeatures", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(CarCondition),
    __metadata("design:type", String)
], LeadPreferenceHistoryDTO.prototype, "carCondition", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(TransmissionType),
    __metadata("design:type", String)
], LeadPreferenceHistoryDTO.prototype, "transmissionType", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(FuelType),
    __metadata("design:type", String)
], LeadPreferenceHistoryDTO.prototype, "fuelType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryDTO.prototype, "additionalPreferences", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryDTO.prototype, "changeReason", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryDTO.prototype, "changedByUserId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", Date)
], LeadPreferenceHistoryDTO.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", Date)
], LeadPreferenceHistoryDTO.prototype, "updatedAt", void 0);
exports.LeadPreferenceHistoryDTO = LeadPreferenceHistoryDTO;
class LeadPreferenceHistoryCreateDTO {
    constructor() {
        this.carCondition = CarCondition.BOTH;
        this.transmissionType = TransmissionType.BOTH;
        this.fuelType = FuelType.ANY;
    }
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(LeadPreferenceHistoryCreateDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryCreateDTO.prototype, "leadId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], LeadPreferenceHistoryCreateDTO.prototype, "budgetMin", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], LeadPreferenceHistoryCreateDTO.prototype, "budgetMax", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryCreateDTO.prototype, "preferredMake", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryCreateDTO.prototype, "preferredModel", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], LeadPreferenceHistoryCreateDTO.prototype, "preferredYearMin", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], LeadPreferenceHistoryCreateDTO.prototype, "preferredYearMax", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], LeadPreferenceHistoryCreateDTO.prototype, "preferredColors", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], LeadPreferenceHistoryCreateDTO.prototype, "preferredFeatures", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(CarCondition),
    __metadata("design:type", String)
], LeadPreferenceHistoryCreateDTO.prototype, "carCondition", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(TransmissionType),
    __metadata("design:type", String)
], LeadPreferenceHistoryCreateDTO.prototype, "transmissionType", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(FuelType),
    __metadata("design:type", String)
], LeadPreferenceHistoryCreateDTO.prototype, "fuelType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryCreateDTO.prototype, "additionalPreferences", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryCreateDTO.prototype, "changeReason", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryCreateDTO.prototype, "changedByUserId", void 0);
exports.LeadPreferenceHistoryCreateDTO = LeadPreferenceHistoryCreateDTO;
class LeadPreferenceHistoryFilter extends global_1.TypedFilter {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], LeadPreferenceHistoryFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], LeadPreferenceHistoryFilter.prototype, "leadId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => core_1.Range),
    __metadata("design:type", core_1.Range)
], LeadPreferenceHistoryFilter.prototype, "budgetRange", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryFilter.prototype, "make", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryFilter.prototype, "model", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => core_1.Range),
    __metadata("design:type", core_1.Range)
], LeadPreferenceHistoryFilter.prototype, "yearRange", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], LeadPreferenceHistoryFilter.prototype, "colors", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], LeadPreferenceHistoryFilter.prototype, "features", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(CarCondition, { each: true }),
    __metadata("design:type", Object)
], LeadPreferenceHistoryFilter.prototype, "carCondition", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(TransmissionType, { each: true }),
    __metadata("design:type", Object)
], LeadPreferenceHistoryFilter.prototype, "transmissionType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(FuelType, { each: true }),
    __metadata("design:type", Object)
], LeadPreferenceHistoryFilter.prototype, "fuelType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], LeadPreferenceHistoryFilter.prototype, "changedByUserId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], LeadPreferenceHistoryFilter.prototype, "search", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], LeadPreferenceHistoryFilter.prototype, "fromDate", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], LeadPreferenceHistoryFilter.prototype, "toDate", void 0);
exports.LeadPreferenceHistoryFilter = LeadPreferenceHistoryFilter;
class LeadPreferenceHistoryGetDTO extends global_1.BaseGetDTO {
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => LeadPreferenceHistoryFilter),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", LeadPreferenceHistoryFilter)
], LeadPreferenceHistoryGetDTO.prototype, "filters", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => global_1.TypedOptions),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", global_1.TypedOptions)
], LeadPreferenceHistoryGetDTO.prototype, "options", void 0);
exports.LeadPreferenceHistoryGetDTO = LeadPreferenceHistoryGetDTO;
